// import React, { useState, useMemo, useEffect } from "react";
// import {
//   Button,
//   Card,
//   Col,
//   Container,
//   Form,
//   Modal,
//   Offcanvas,
//   Row,
// } from "react-bootstrap";
// import Breadcrumb from "Common/BreadCrumb";
// import TableContainer from "Common/TableContainer";
// import { couponsList } from "Common/data";
// import { Link } from "react-router-dom";
// import Flatpickr from "react-flatpickr";
// import offerbanner from "../../assets/images/ecommerce/offer-banner.jpg";
// import {
//   fetchCoupons,
//   createCoupon,
//   updateCoupon,
//   deleteCoupon,
// } from "api/apis";
// import { CreateCouponPayload, UpdateCouponPayload } from "interface";

// interface FormData {
//   code: string;
//   discountType: "percentage" | "fixed";
//   discountValue: string;
//   minimumPurchaseAmount: string;
//   startDate: string;
//   expiryDate: string;
//   usageLimit: string;
//   isActive: boolean;
//   image?: File | null; // Add image field
//   existingImageUrl?: string; // For edit mode
// }

// const Coupons = () => {
//   document.title = "Coupons | Toner eCommerce + Admin React Template";

//   const [showCoupons, setShowCoupons] = useState<boolean>(false);
//   const [showCouponDetails, setShowCouponsDetails] = useState<any>({});
//   const [coupons, setCoupons] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [formErrors, setFormErrors] = useState<any>({});
//   const [editingCouponId, setEditingCouponId] = useState<string | null>(null);
//   const [selectedCouponId, setSelectedCouponId] = useState<string | null>(null);
//   const [deleteModal, setDeleteModal] = useState<boolean>(false);
//   const [searchTerm, setSearchTerm] = useState("");

//   const handleDeleteCoupon = async () => {
//     if (!selectedCouponId) return;

//     try {
//       setLoading(true);
//       await deleteCoupon(selectedCouponId);

//       // Refresh coupons list
//       const updatedCoupons = await fetchCoupons();
//       setCoupons(updatedCoupons);

//       // Close modal and reset
//       setDeleteModal(false);
//       setSelectedCouponId(null);
//     } catch (error) {
//       console.error("Failed to delete coupon:", error);
//       // You can add error notification here
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Form state
//   // Update the form state interface

//   // Update the initial state
//   const [formData, setFormData] = useState<FormData>({
//     code: "",
//     discountType: "percentage",
//     discountValue: "",
//     minimumPurchaseAmount: "",
//     startDate: "",
//     expiryDate: "",
//     usageLimit: "",
//     isActive: true,
//     image: null,
//     existingImageUrl: "",
//   });

//   //   const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//   //     if (e.target.files && e.target.files.length > 0) {
//   //       setFormData((prev) => ({
//   //         ...prev,
//   //         image: e.target.files![0],
//   //       }));
//   //     }
//   //   };

//   useEffect(() => {
//     const getAllCoupons = async () => {
//       try {
//         const data = await fetchCoupons();
//         console.log("Coupon Code : ", data[0].code);
//         setCoupons(data);
//       } catch (error) {
//         console.error("Failed to fetch coupons", error);
//       }
//     };

//     getAllCoupons();
//   }, []);

//   const formatDate = (dateString: string) => {
//     const date = new Date(dateString);
//     return date.toLocaleDateString("en-US", {
//       day: "numeric",
//       month: "short",
//       year: "numeric",
//     });
//   };

//   const getStatus = (coupon: any) => {
//     const now = new Date();
//     const expiryDate = new Date(coupon.expiryDate);

//     if (!coupon.isActive) return "Inactive";
//     if (now > expiryDate) return "Expired";
//     return "Active";
//   };

//   // Handle input changes
//   const handleInputChange = (e: React.ChangeEvent<any>) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));

//     // Clear error for this field
//     if (formErrors[name]) {
//       setFormErrors((prev: any) => ({
//         ...prev,
//         [name]: "",
//       }));
//     }
//   };

//   // Handle date changes
//   const handleDateChange = (fieldName: string) => (date: Date[]) => {
//     if (date.length > 0) {
//       const selectedDate = date[0];
//       // Convert to ISO string format that matches your API
//       const isoString = selectedDate.toISOString();
//       setFormData((prev) => ({
//         ...prev,
//         [fieldName]: isoString,
//       }));

//       // Clear error for this field
//       if (formErrors[fieldName]) {
//         setFormErrors((prev: any) => ({
//           ...prev,
//           [fieldName]: "",
//         }));
//       }
//     }
//   };

//   // Validate form
//   const validateForm = () => {
//     const errors: any = {};

//     if (!formData.code.trim()) {
//       errors.code = "Coupon code is required";
//     }

//     if (!formData.discountValue || Number(formData.discountValue) <= 0) {
//       errors.discountValue = "Discount value must be greater than 0";
//     }

//     if (!formData.startDate) {
//       errors.startDate = "Start date is required";
//     }

//     if (!formData.expiryDate) {
//       errors.expiryDate = "Expiry date is required";
//     }

//     if (formData.startDate && formData.expiryDate) {
//       const startDate = new Date(formData.startDate);
//       const expiryDate = new Date(formData.expiryDate);
//       if (startDate >= expiryDate) {
//         errors.expiryDate = "Expiry date must be after start date";
//       }
//     }

//     if (
//       formData.minimumPurchaseAmount &&
//       Number(formData.minimumPurchaseAmount) < 0
//     ) {
//       errors.minimumPurchaseAmount =
//         "Minimum purchase amount cannot be negative";
//     }

//     if (formData.usageLimit && Number(formData.usageLimit) <= 0) {
//       errors.usageLimit = "Usage limit must be greater than 0";
//     }

//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const handleSubmit = async (e: React.FormEvent) => {
//     e.preventDefault();

//     if (!validateForm()) {
//       return;
//     }

//     setLoading(true);

//     try {
//       if (isEditMode && editingCouponId) {
//         // Update existing coupon
//         const payload: UpdateCouponPayload = {
//           code: formData.code.trim(),
//           discountType: formData.discountType,
//           discountValue: Number(formData.discountValue),
//           startDate: formData.startDate,
//           expiryDate: formData.expiryDate,
//           isActive: formData.isActive,
//         };

//         // Add optional fields only if they have values
//         if (formData.minimumPurchaseAmount) {
//           payload.minimumPurchaseAmount = Number(
//             formData.minimumPurchaseAmount
//           );
//         }

//         if (formData.usageLimit) {
//           payload.usageLimit = Number(formData.usageLimit);
//         }

//         await updateCoupon(editingCouponId, payload);
//         console.log("Coupon updated successfully!");
//       } else {
//         // Create new coupon
//         // Check if we have an image to upload
//         if (formData.image) {
//           // Use FormData for image upload
//           const formDataPayload = new FormData();
//           formDataPayload.append("code", formData.code.trim());
//           formDataPayload.append("discountType", formData.discountType);
//           formDataPayload.append(
//             "discountValue",
//             Number(formData.discountValue).toString()
//           );
//           formDataPayload.append("startDate", formData.startDate);
//           formDataPayload.append("expiryDate", formData.expiryDate);

//           if (formData.minimumPurchaseAmount) {
//             formDataPayload.append(
//               "minimumPurchaseAmount",
//               Number(formData.minimumPurchaseAmount).toString()
//             );
//           }

//           if (formData.usageLimit) {
//             formDataPayload.append(
//               "usageLimit",
//               Number(formData.usageLimit).toString()
//             );
//           }

//           formDataPayload.append("image", formData.image);

//           await createCoupon(formDataPayload);
//         } else {
//           // Use regular JSON payload when no image
//           const payload: CreateCouponPayload = {
//             code: formData.code.trim(),
//             discountType: formData.discountType,
//             discountValue: Number(formData.discountValue),
//             startDate: formData.startDate,
//             expiryDate: formData.expiryDate,
//           };

//           // Add optional fields only if they have values
//           if (formData.minimumPurchaseAmount) {
//             payload.minimumPurchaseAmount = Number(
//               formData.minimumPurchaseAmount
//             );
//           }

//           if (formData.usageLimit) {
//             payload.usageLimit = Number(formData.usageLimit);
//           }

//           await createCoupon(payload);
//         }

//         console.log("Coupon created successfully!");
//       }

//       // Reset form and close modal
//       resetForm();
//       setmodal_AddCouponsModals(false);

//       // Refresh coupons list
//       const updatedCoupons = await fetchCoupons();
//       setCoupons(updatedCoupons);
//     } catch (error) {
//       console.error(
//         `Failed to ${isEditMode ? "update" : "create"} coupon:`,
//         error
//       );
//       // You can add error notification here
//     } finally {
//       setLoading(false);
//     }
//   };

//   // 3. Add image preview functionality to handleImageChange:
//   const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     if (e.target.files && e.target.files.length > 0) {
//       const file = e.target.files[0];

//       // Optional: Add file size validation (e.g., max 5MB)
//       if (file.size > 5 * 1024 * 1024) {
//         alert("File size should be less than 5MB");
//         return;
//       }

//       // Optional: Add file type validation
//       if (!file.type.startsWith("image/")) {
//         alert("Please select a valid image file");
//         return;
//       }

//       setFormData((prev) => ({
//         ...prev,
//         image: file,
//       }));
//     }
//   };

//   // 4. Update the resetForm function to clear image:
//   const resetForm = () => {
//     setFormData({
//       code: "",
//       discountType: "percentage",
//       discountValue: "",
//       minimumPurchaseAmount: "",
//       startDate: "",
//       expiryDate: "",
//       usageLimit: "",
//       isActive: true,
//       image: null,
//       existingImageUrl: "",
//     });
//     setFormErrors({});
//     setIsEditMode(false);
//     setEditingCouponId(null);

//     // Clear file input
//     const fileInput = document.getElementById("image") as HTMLInputElement;
//     if (fileInput) {
//       fileInput.value = "";
//     }
//   };

//   // Function to handle edit button click
//   const handleEditCoupon = (coupon: any) => {
//     setIsEditMode(true);
//     setEditingCouponId(coupon._id || coupon.id);

//     setFormData({
//       code: coupon.code || "",
//       discountType: coupon.discountType || "percentage",
//       discountValue: coupon.discountValue?.toString() || "",
//       minimumPurchaseAmount: coupon.minimumPurchaseAmount?.toString() || "",
//       startDate: coupon.startDate || "",
//       expiryDate: coupon.expiryDate || "",
//       usageLimit: coupon.usageLimit?.toString() || "",
//       isActive: coupon.isActive !== undefined ? coupon.isActive : true,
//       image: null,
//       existingImageUrl: coupon.imageUrl || "",
//     });

//     setmodal_AddCouponsModals(true);
//   };

//   const columns = useMemo(
//     () => [
//       {
//         Header: "Image",
//         disableFilters: true,
//         filterable: false,
//         accessor: (cellProps: any) => {
//           return (
//             <div className="avatar-sm">
//               <img
//                 src={cellProps.imageUrl || offerbanner}
//                 alt={cellProps.code}
//                 className="img-thumbnail"
//                 style={{ width: "40px", height: "40px", objectFit: "cover" }}
//               />
//             </div>
//           );
//         },
//       },
//       {
//         Header: "Discount",
//         disableFilters: true,
//         filterable: true,
//         accessor: (cellProps: any) => {
//           return (
//             <h5 className="mb-0 fs-16">
//               {cellProps.discountType === "percentage"
//                 ? `${cellProps.discountValue}%`
//                 : `₹${cellProps.discountValue}`}
//             </h5>
//           );
//         },
//       },
//       {
//         Header: "Coupon Code",
//         accessor: "code",
//         disableFilters: true,
//         filterable: true,
//       },
//       {
//         Header: "Min. Purchase",
//         disableFilters: true,
//         filterable: true,
//         accessor: (cellProps: any) => {
//           return cellProps.minimumPurchaseAmount > 0
//             ? `₹${cellProps.minimumPurchaseAmount}`
//             : "No minimum";
//         },
//       },
//       {
//         Header: "Start Date",
//         disableFilters: true,
//         filterable: true,
//         accessor: (cellProps: any) => {
//           return formatDate(cellProps.startDate);
//         },
//       },
//       {
//         Header: "Expiry Date",
//         disableFilters: true,
//         filterable: true,
//         accessor: (cellProps: any) => {
//           return formatDate(cellProps.expiryDate);
//         },
//       },
//       {
//         Header: "Usage",
//         disableFilters: true,
//         filterable: true,
//         accessor: (cellProps: any) => {
//           return `${cellProps.usedCount}/${cellProps.usageLimit || "∞"}`;
//         },
//       },
//       {
//         Header: "Status",
//         disableFilters: true,
//         filterable: true,
//         accessor: (cellProps: any) => {
//           const status = getStatus(cellProps);
//           switch (status) {
//             case "Active":
//               return (
//                 <span className="badge bg-success-subtle text-success text-uppercase">
//                   {status}
//                 </span>
//               );
//             case "Expired":
//               return (
//                 <span className="badge bg-danger-subtle text-danger text-uppercase">
//                   {status}
//                 </span>
//               );
//             case "Inactive":
//               return (
//                 <span className="badge bg-secondary-subtle text-secondary text-uppercase">
//                   {status}
//                 </span>
//               );
//             default:
//               return (
//                 <span className="badge bg-success-subtle text-success text-uppercase">
//                   {status}
//                 </span>
//               );
//           }
//         },
//       },
//       {
//         Header: "Action",
//         disableFilters: true,
//         filterable: true,
//         accessor: (cellProps: any) => {
//           return (
//             <ul className="hstack gap-2 list-unstyled mb-0">
//               <li>
//                 <Link
//                   to="#couponDetails"
//                   data-bs-toggle="offcanvas"
//                   className="badge bg-dark-subtle text-body view-item-btn"
//                   onClick={() => {
//                     setShowCouponsDetails(cellProps);
//                     setShowCoupons(!showCoupons);
//                   }}
//                 >
//                   View
//                 </Link>
//               </li>
//               <li>
//                 <Button
//                   variant="link"
//                   className="badge bg-primary-subtle text-primary edit-item-btn p-0 border-0"
//                   onClick={() => handleEditCoupon(cellProps)}
//                 >
//                   Edit
//                 </Button>
//               </li>
//               <li>
//                 <Button
//                   variant="link"
//                   className="badge bg-danger-subtle text-danger remove-item-btn p-0 border-0"
//                   onClick={() => {
//                     setSelectedCouponId(cellProps._id || cellProps.id);
//                     setDeleteModal(true);
//                   }}
//                 >
//                   Delete
//                 </Button>
//               </li>
//             </ul>
//           );
//         },
//       },
//     ],
//     [showCoupons]
//   );

//   const [modal_AddCouponsModals, setmodal_AddCouponsModals] =
//     useState<boolean>(false);

//   const tog_AddCouponsModals = () => {
//     if (modal_AddCouponsModals) {
//       // Reset form when closing modal
//       resetForm();
//     }
//     setmodal_AddCouponsModals(!modal_AddCouponsModals);
//   };

//   const filteredCoupons = useMemo(() => {
//     if (!searchTerm) return coupons;

//     return coupons.filter((coupon: any) => {
//       return coupon.code.toLowerCase().includes(searchTerm.toLowerCase());
//     });
//   }, [coupons, searchTerm]);

//   return (
//     <React.Fragment>
//       <div className="page-content">
//         <Container fluid={true}>
//           <Breadcrumb title="Coupons" pageTitle="More" />
//           <div id="couponsList">
//             <Row>
//               <Col xxl={12}>
//                 <Card>
//                   <Card.Body>
//                     <Row className="align-items-center">
//                       <Col xxl={3} md={5}>
//                         <div className="search-box mb-3 mb-md-0">
//                           <input
//                             type="text"
//                             className="form-control search"
//                             id="searchProductList"
//                             placeholder="Search by coupons code & name..."
//                             value={searchTerm}
//                             onChange={(e) => setSearchTerm(e.target.value)}
//                           />
//                           <i className="ri-search-line search-icon"></i>
//                         </div>
//                       </Col>
//                       <Col className="col-md-auto ms-auto">
//                         <Button
//                           variant="success"
//                           onClick={tog_AddCouponsModals}
//                           className="add-btn"
//                         >
//                           <i className="bi bi-plus-circle me-1 align-middle"></i>
//                           Add Coupon
//                         </Button>
//                       </Col>
//                     </Row>
//                   </Card.Body>
//                 </Card>
//               </Col>
//             </Row>

//             <Row>
//               <Col lg={12}>
//                 <Card>
//                   <Card.Body className="p-0">
//                     <TableContainer
//                       columns={columns || []}
//                       data={filteredCoupons} // Use filteredCoupons instead of coupons
//                       iscustomPageSize={false}
//                       isBordered={false}
//                       customPageSize={10}
//                       className="custom-header-css table align-middle table-nowrap"
//                       tableClass="table-centered align-middle table-nowrap mb-0"
//                       theadClass="text-muted table-light"
//                       SearchPlaceholder="Search Products..."
//                     />
//                     <div className="noresult" style={{ display: "none" }}>
//                       <div className="text-center">
//                         <h5 className="mt-2">Sorry! No Result Found</h5>
//                         <p className="text-muted mb-0">
//                           We've searched more than 150+ Orders We did not find
//                           any orders for you search.
//                         </p>
//                       </div>
//                     </div>
//                   </Card.Body>
//                 </Card>
//               </Col>
//             </Row>
//           </div>

//           <Modal
//             id="showModal"
//             className="fade zoomIn"
//             size="lg"
//             show={modal_AddCouponsModals}
//             onHide={tog_AddCouponsModals}
//             centered
//           >
//             <Modal.Header className="px-4 pt-4" closeButton>
//               <h5 className="modal-title fs-18" id="exampleModalLabel">
//                 {isEditMode ? "Edit Coupon" : "Add Coupon"}
//               </h5>
//             </Modal.Header>
//             <Modal.Body className="p-4">
//               <Form className="tablelist-form" onSubmit={handleSubmit}>
//                 <Row>
//                   <Col lg={6}>
//                     <div className="mb-3">
//                       <Form.Label htmlFor="code">
//                         Coupon Code <span className="text-danger">*</span>
//                       </Form.Label>
//                       <Form.Control
//                         type="text"
//                         id="code"
//                         name="code"
//                         value={formData.code}
//                         onChange={handleInputChange}
//                         placeholder="Enter coupon code"
//                         isInvalid={!!formErrors.code}
//                         required
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         {formErrors.code}
//                       </Form.Control.Feedback>
//                     </div>
//                   </Col>
//                   <Col lg={6}>
//                     <div className="mb-3">
//                       <Form.Label htmlFor="discountType">
//                         Discount Type <span className="text-danger">*</span>
//                       </Form.Label>
//                       <Form.Select
//                         name="discountType"
//                         id="discountType"
//                         value={formData.discountType}
//                         onChange={handleInputChange}
//                       >
//                         <option value="percentage">Percentage</option>
//                         <option value="fixed">Fixed Amount</option>
//                       </Form.Select>
//                     </div>
//                   </Col>
//                   <Col lg={6}>
//                     <div className="mb-3">
//                       <Form.Label htmlFor="discountValue">
//                         Discount Value <span className="text-danger">*</span>
//                       </Form.Label>
//                       <Form.Control
//                         type="number"
//                         id="discountValue"
//                         name="discountValue"
//                         value={formData.discountValue}
//                         onChange={handleInputChange}
//                         placeholder="Enter discount value"
//                         min="0"
//                         step="0.01"
//                         isInvalid={!!formErrors.discountValue}
//                         required
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         {formErrors.discountValue}
//                       </Form.Control.Feedback>
//                     </div>
//                   </Col>
//                   <Col lg={6}>
//                     <div className="mb-3">
//                       <Form.Label htmlFor="minimumPurchaseAmount">
//                         Minimum Purchase Amount (₹)
//                       </Form.Label>
//                       <Form.Control
//                         type="number"
//                         id="minimumPurchaseAmount"
//                         name="minimumPurchaseAmount"
//                         value={formData.minimumPurchaseAmount}
//                         onChange={handleInputChange}
//                         placeholder="Enter minimum purchase amount"
//                         min="0"
//                         isInvalid={!!formErrors.minimumPurchaseAmount}
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         {formErrors.minimumPurchaseAmount}
//                       </Form.Control.Feedback>
//                     </div>
//                   </Col>
//                   <Col lg={6}>
//                     <div className="mb-3">
//                       <Form.Label htmlFor="startDate">
//                         Start Date <span className="text-danger">*</span>
//                       </Form.Label>
//                       <Flatpickr
//                         className={`form-control flatpickr-input ${
//                           formErrors.startDate ? "is-invalid" : ""
//                         }`}
//                         placeholder="Select start date"
//                         options={{
//                           dateFormat: "d M, Y",
//                           minDate: "today",
//                         }}
//                         value={formData.startDate}
//                         onChange={handleDateChange("startDate")}
//                       />
//                       {formErrors.startDate && (
//                         <div className="invalid-feedback d-block">
//                           {formErrors.startDate}
//                         </div>
//                       )}
//                     </div>
//                   </Col>
//                   <Col lg={6}>
//                     <div className="mb-3">
//                       <Form.Label htmlFor="expiryDate">
//                         Expiry Date <span className="text-danger">*</span>
//                       </Form.Label>
//                       <Flatpickr
//                         className={`form-control flatpickr-input ${
//                           formErrors.expiryDate ? "is-invalid" : ""
//                         }`}
//                         placeholder="Select expiry date"
//                         options={{
//                           dateFormat: "d M, Y",
//                           minDate: formData.startDate || "today",
//                         }}
//                         value={formData.expiryDate}
//                         onChange={handleDateChange("expiryDate")}
//                       />
//                       {formErrors.expiryDate && (
//                         <div className="invalid-feedback d-block">
//                           {formErrors.expiryDate}
//                         </div>
//                       )}
//                     </div>
//                   </Col>
//                   <Col lg={6}>
//                     <div className="mb-3">
//                       <Form.Label htmlFor="usageLimit">
//                         Usage Limit (leave blank for unlimited)
//                       </Form.Label>
//                       <Form.Control
//                         type="number"
//                         id="usageLimit"
//                         name="usageLimit"
//                         value={formData.usageLimit}
//                         onChange={handleInputChange}
//                         placeholder="Enter usage limit"
//                         min="1"
//                         isInvalid={!!formErrors.usageLimit}
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         {formErrors.usageLimit}
//                       </Form.Control.Feedback>
//                     </div>
//                   </Col>

//                   <Col lg={6}>
//                     <div className="mb-3">
//                       <Form.Label htmlFor="image">Coupon Image</Form.Label>
//                       <Form.Control
//                         type="file"
//                         id="image"
//                         name="image"
//                         accept="image/*"
//                         onChange={handleImageChange}
//                       />
//                       {formData.existingImageUrl && (
//                         <div className="mt-2">
//                           <img
//                             src={formData.existingImageUrl}
//                             alt="Current coupon"
//                             style={{
//                               width: "100px",
//                               height: "60px",
//                               objectFit: "cover",
//                             }}
//                             className="img-thumbnail"
//                           />
//                           <small className="text-muted d-block">
//                             Current image
//                           </small>
//                         </div>
//                       )}
//                     </div>
//                   </Col>

//                   {isEditMode && (
//                     <Col lg={6}>
//                       <div className="mb-3">
//                         <Form.Label htmlFor="isActive">Status</Form.Label>
//                         <Form.Select
//                           name="isActive"
//                           id="isActive"
//                           value={formData.isActive.toString()}
//                           onChange={(e) =>
//                             setFormData((prev) => ({
//                               ...prev,
//                               isActive: e.target.value === "true",
//                             }))
//                           }
//                         >
//                           <option value="true">Active</option>
//                           <option value="false">Inactive</option>
//                         </Form.Select>
//                       </div>
//                     </Col>
//                   )}
//                   <Col lg={12} className="modal-footer">
//                     <div className="hstack gap-2 justify-content-end">
//                       <Button
//                         variant="light"
//                         onClick={tog_AddCouponsModals}
//                         disabled={loading}
//                       >
//                         <i className="ri-close-line align-bottom me-1"></i>
//                         Close
//                       </Button>
//                       <Button
//                         variant="primary"
//                         type="submit"
//                         disabled={loading}
//                       >
//                         {loading ? (
//                           <>
//                             <span
//                               className="spinner-border spinner-border-sm me-1"
//                               role="status"
//                               aria-hidden="true"
//                             ></span>
//                             {isEditMode ? "Updating..." : "Creating..."}
//                           </>
//                         ) : (
//                           <>
//                             <i
//                               className={`ri-${
//                                 isEditMode ? "edit" : "save"
//                               }-line align-bottom me-1`}
//                             ></i>
//                             {isEditMode ? "Update Coupon" : "Add Coupon"}
//                           </>
//                         )}
//                       </Button>
//                     </div>
//                   </Col>
//                 </Row>
//               </Form>
//             </Modal.Body>
//           </Modal>
//         </Container>
//       </div>

//       <Offcanvas
//         show={showCoupons}
//         onHide={() => setShowCoupons(!showCoupons)}
//         placement="end"
//       >
//         <Offcanvas.Header closeButton>
//           <Offcanvas.Title>
//             {showCouponDetails.code || "Coupon Details"}
//           </Offcanvas.Title>
//         </Offcanvas.Header>
//         <Offcanvas.Body>
//           <div>
//             <img
//               src={showCouponDetails.imageUrl || offerbanner}
//               alt=""
//               className="img-thumbnail"
//             />
//           </div>
//           <div className="mt-3">
//             <div className="table-responsive">
//               <table className="table table-borderless">
//                 <tbody>
//                   <tr>
//                     <td>
//                       <span className="text-muted">Code</span>
//                     </td>
//                     <td>
//                       <span className="fw-medium">
//                         {showCouponDetails.code}
//                       </span>
//                     </td>
//                   </tr>
//                   <tr>
//                     <td>
//                       <span className="text-muted">Discount</span>
//                     </td>
//                     <td>
//                       <span className="fw-medium text-uppercase">
//                         {showCouponDetails.discountType === "percentage"
//                           ? `${showCouponDetails.discountValue}%`
//                           : `₹${showCouponDetails.discountValue}`}
//                       </span>
//                     </td>
//                   </tr>
//                   <tr>
//                     <td>
//                       <span className="text-muted">Min. Purchase</span>
//                     </td>
//                     <td>
//                       <span className="fw-medium">
//                         {showCouponDetails.minimumPurchaseAmount > 0
//                           ? `₹${showCouponDetails.minimumPurchaseAmount}`
//                           : "No minimum"}
//                       </span>
//                     </td>
//                   </tr>
//                   <tr>
//                     <td>
//                       <span className="text-muted">Start Date</span>
//                     </td>
//                     <td>
//                       <span className="fw-medium">
//                         {showCouponDetails.startDate &&
//                           formatDate(showCouponDetails.startDate)}
//                       </span>
//                     </td>
//                   </tr>
//                   <tr>
//                     <td>
//                       <span className="text-muted">Expiry Date</span>
//                     </td>
//                     <td>
//                       <span className="fw-medium">
//                         {showCouponDetails.expiryDate &&
//                           formatDate(showCouponDetails.expiryDate)}
//                       </span>
//                     </td>
//                   </tr>
//                   <tr>
//                     <td>
//                       <span className="text-muted">Usage</span>
//                     </td>
//                     <td>
//                       <span className="fw-medium">
//                         {showCouponDetails.usedCount}/
//                         {showCouponDetails.usageLimit || "∞"}
//                       </span>
//                     </td>
//                   </tr>
//                   <tr>
//                     <td>
//                       <span className="text-muted">Status</span>
//                     </td>
//                     <td>
//                       <span
//                         className={
//                           getStatus(showCouponDetails) === "Expired"
//                             ? "badge bg-danger-subtle text-danger text-uppercase"
//                             : getStatus(showCouponDetails) === "Inactive"
//                             ? "badge bg-secondary-subtle text-secondary text-uppercase"
//                             : "badge bg-success-subtle text-success text-uppercase"
//                         }
//                       >
//                         {getStatus(showCouponDetails)}
//                       </span>
//                     </td>
//                   </tr>
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </Offcanvas.Body>
//       </Offcanvas>

//       {/* Delete Modal */}
//       <Modal show={deleteModal} onHide={() => setDeleteModal(false)} centered>
//         <Modal.Header closeButton>
//           <Modal.Title as="h5">Delete Coupon</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p>
//             Are you sure you want to delete this coupon? This action cannot be
//             undone.
//           </p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="light" onClick={() => setDeleteModal(false)}>
//             Cancel
//           </Button>
//           <Button
//             variant="danger"
//             onClick={handleDeleteCoupon}
//             disabled={loading}
//           >
//             {loading ? (
//               <>
//                 <span
//                   className="spinner-border spinner-border-sm me-1"
//                   role="status"
//                   aria-hidden="true"
//                 ></span>
//                 Deleting...
//               </>
//             ) : (
//               "Delete"
//             )}
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </React.Fragment>
//   );
// };

// export default Coupons;

import React, { useState, useMemo, useEffect } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Modal,
  Offcanvas,
  Row,
} from "react-bootstrap";
import Breadcrumb from "Common/BreadCrumb";
import TableContainer from "Common/TableContainer";
import { couponsList } from "Common/data";
import { Link } from "react-router-dom";
import Flatpickr from "react-flatpickr";
import offerbanner from "../../assets/images/ecommerce/offer-banner.jpg";
import {
  fetchCoupons,
  createCoupon,
  updateCoupon,
  deleteCoupon,
} from "api/apis";
import { CreateCouponPayload, UpdateCouponPayload } from "interface";
import { toast } from "react-toastify";

interface FormData {
  code: string;
  discountType: "percentage" | "fixed";
  discountValue: string;
  minimumPurchaseAmount: string;
  startDate: string;
  expiryDate: string;
  usageLimit: string;
  isActive: boolean;
  isAbandonedCoupon: boolean;
  isNewUserCoupon: boolean;
  maxDiscountAmount: string;
  validForUsers: string[];
}

const Coupons = () => {
  document.title = "Coupons";

  const [showCoupons, setShowCoupons] = useState<boolean>(false);
  const [showCouponDetails, setShowCouponsDetails] = useState<any>({});
  const [coupons, setCoupons] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [formErrors, setFormErrors] = useState<any>({});
  const [editingCouponId, setEditingCouponId] = useState<string | null>(null);
  const [selectedCouponId, setSelectedCouponId] = useState<string | null>(null);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [userInput, setUserInput] = useState("");
  const [validForUsers, setValidForUsers] = useState<string[]>([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const handleDeleteCoupon = async () => {
    if (!selectedCouponId) return;

    try {
      setLoading(true);
      await deleteCoupon(selectedCouponId);
      toast.info("Coupon Deleted Successfully");

      // Refresh coupons list
      const updatedCoupons = await fetchCoupons();
      setCoupons(updatedCoupons);

      // Close modal and reset
      setDeleteModal(false);
      setSelectedCouponId(null);
    } catch (error: any) {
      console.error("Failed to delete coupon:", error);
      toast.error("Failed to delete coupon:", error);
    } finally {
      setLoading(false);
    }
  };

  const [formData, setFormData] = useState<FormData>({
    code: "",
    discountType: "percentage",
    discountValue: "",
    minimumPurchaseAmount: "",
    startDate: "",
    expiryDate: "",
    usageLimit: "",
    isActive: true,
    isAbandonedCoupon: false,
    isNewUserCoupon: false,
    maxDiscountAmount: "",
    validForUsers: [],
  });

  useEffect(() => {
    const getAllCoupons = async () => {
      try {
        setLoading(true);
        const data = await fetchCoupons();
        console.log("Fetched coupons:", data);
        setCoupons(data);
      } catch (error) {
        console.error("Failed to fetch coupons", error);
      } finally {
        setLoading(false);
      }
    };

    getAllCoupons();
  }, []);

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  };

  const getStatus = (coupon: any) => {
    const now = new Date();
    const expiryDate = new Date(coupon.expiryDate);

    if (!coupon.isActive) return "Inactive";
    if (now > expiryDate) return "Expired";
    return "Active";
  };

  const handleInputChange = (e: React.ChangeEvent<any>) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    // Clear error for this field
    if (formErrors[name]) {
      setFormErrors((prev: any) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleDateChange = (fieldName: string) => (date: Date[]) => {
    if (date.length > 0) {
      const selectedDate = date[0];
      const isoString = selectedDate.toISOString();
      setFormData((prev) => ({
        ...prev,
        [fieldName]: isoString,
      }));

      // Clear error for this field
      if (formErrors[fieldName]) {
        setFormErrors((prev: any) => ({
          ...prev,
          [fieldName]: "",
        }));
      }
    }
  };

  const validateForm = () => {
    const errors: any = {};

    if (!formData.code.trim()) {
      errors.code = "Coupon code is required";
    }

    if (!formData.discountValue || Number(formData.discountValue) <= 0) {
      errors.discountValue = "Discount value must be greater than 0";
    }

    if (
      formData.discountType === "percentage" &&
      Number(formData.discountValue) > 100
    ) {
      errors.discountValue = "Percentage discount cannot exceed 100%";
    }
    if (
      formData.discountType === "percentage" &&
      formData.maxDiscountAmount &&
      Number(formData.maxDiscountAmount) <= 0
    ) {
      errors.maxDiscountAmount = "Max discount amount must be greater than 0";
    }

    if (!formData.startDate) {
      errors.startDate = "Start date is required";
    }

    if (!formData.expiryDate) {
      errors.expiryDate = "Expiry date is required";
    }

    if (formData.startDate && formData.expiryDate) {
      const startDate = new Date(formData.startDate);
      const expiryDate = new Date(formData.expiryDate);
      if (startDate >= expiryDate) {
        errors.expiryDate = "Expiry date must be after start date";
      }
    }

    if (
      formData.minimumPurchaseAmount &&
      Number(formData.minimumPurchaseAmount) < 0
    ) {
      errors.minimumPurchaseAmount =
        "Minimum purchase amount cannot be negative";
    }

    if (formData.usageLimit && Number(formData.usageLimit) <= 0) {
      errors.usageLimit = "Usage limit must be greater than 0";
    }

    if (formData.maxDiscountAmount && Number(formData.maxDiscountAmount) <= 0) {
      errors.maxDiscountAmount = "Max discount amount must be greater than 0";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleAddUser = () => {
    if (userInput.trim() && !validForUsers.includes(userInput.trim())) {
      setValidForUsers([...validForUsers, userInput.trim()]);
      setUserInput("");
    }
  };

  const handleRemoveUser = (userId: string) => {
    setValidForUsers(validForUsers.filter((id) => id !== userId));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setLoading(true);

    try {
      if (isEditMode && editingCouponId) {
        // Update existing coupon
        const payload: UpdateCouponPayload = {
          code: formData.code.trim(),
          discountType: formData.discountType,
          discountValue: Number(formData.discountValue),
          startDate: formData.startDate,
          expiryDate: formData.expiryDate,
          isActive: formData.isActive,
          isAbandonedCoupon: formData.isAbandonedCoupon,
          isNewUserCoupon: formData.isNewUserCoupon,
          validForUsers: validForUsers.length > 0 ? validForUsers : undefined,
        };

        // Add optional fields only if they have values
        if (formData.minimumPurchaseAmount) {
          payload.minimumPurchaseAmount = Number(
            formData.minimumPurchaseAmount
          );
        }

        if (formData.usageLimit) {
          payload.usageLimit = Number(formData.usageLimit);
        }

        if (
          formData.discountType === "percentage" &&
          formData.maxDiscountAmount
        ) {
          payload.maxDiscountAmount = Number(formData.maxDiscountAmount);
        }

        await updateCoupon(editingCouponId, payload);
        toast.success("Coupon Updated Successfully");
      } else {
        // Create new coupon
        const payload: CreateCouponPayload = {
          code: formData.code.trim(),
          discountType: formData.discountType,
          discountValue: Number(formData.discountValue),
          startDate: formData.startDate,
          expiryDate: formData.expiryDate,
          isAbandonedCoupon: formData.isAbandonedCoupon,
          isNewUserCoupon: formData.isNewUserCoupon,
          validForUsers: validForUsers.length > 0 ? validForUsers : undefined,
        };

        // Add optional fields only if they have values
        if (formData.minimumPurchaseAmount) {
          payload.minimumPurchaseAmount = Number(
            formData.minimumPurchaseAmount
          );
        }

        if (formData.usageLimit) {
          payload.usageLimit = Number(formData.usageLimit);
        }

        if (formData.maxDiscountAmount) {
          payload.maxDiscountAmount = Number(formData.maxDiscountAmount);
        }

        await createCoupon(payload);
        toast.success("Coupon Created Successfully");
      }

      // Reset form and close modal
      resetForm();
      setmodal_AddCouponsModals(false);

      // Refresh coupons list
      const updatedCoupons = await fetchCoupons();
      setCoupons(updatedCoupons);
    } catch (error: any) {
      // console.error(
      //   `Failed to ${isEditMode ? "update" : "create"} coupon:`,
      //   error
      // );
      toast.error("Failed to Updated Coupon", error);
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setFormData({
      code: "",
      discountType: "percentage",
      discountValue: "",
      minimumPurchaseAmount: "",
      startDate: "",
      expiryDate: "",
      usageLimit: "",
      isActive: true,
      isAbandonedCoupon: false,
      isNewUserCoupon: false,
      maxDiscountAmount: "",
      validForUsers: [],
    });
    setValidForUsers([]);
    setFormErrors({});
    setIsEditMode(false);
    setEditingCouponId(null);
  };

  const handleEditCoupon = (coupon: any) => {
    setIsEditMode(true);
    setEditingCouponId(coupon._id || coupon.id);
    setValidForUsers(coupon.validForUsers || []);

    setFormData({
      code: coupon.code || "",
      discountType: coupon.discountType || "percentage",
      discountValue: coupon.discountValue?.toString() || "",
      minimumPurchaseAmount: coupon.minimumPurchaseAmount?.toString() || "",
      startDate: coupon.startDate || "",
      expiryDate: coupon.expiryDate || "",
      usageLimit: coupon.usageLimit?.toString() || "",
      isActive: coupon.isActive !== undefined ? coupon.isActive : true,
      isAbandonedCoupon: coupon.isAbandonedCoupon || false,
      isNewUserCoupon: coupon.isNewUserCoupon || false,
      maxDiscountAmount:
        coupon.discountType === "percentage"
          ? coupon.maxDiscountAmount?.toString() || ""
          : "",
      validForUsers: coupon.validForUsers || [],
    });

    setmodal_AddCouponsModals(true);
  };

  const columns = useMemo(
    () => [
      {
        Header: "Discount",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps: any) => {
          return (
            <h5 className="mb-0 fs-16">
              {cellProps.discountType === "percentage"
                ? `${cellProps.discountValue}%`
                : `₹${cellProps.discountValue}`}
            </h5>
          );
        },
      },
      {
        Header: "Coupon Code",
        accessor: "code",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Min. Purchase",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps: any) => {
          return cellProps.minimumPurchaseAmount > 0
            ? `₹${cellProps.minimumPurchaseAmount}`
            : "No minimum";
        },
      },
      {
        Header: "Max Discount",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps: any) => {
          return cellProps.maxDiscountAmount
            ? `₹${cellProps.maxDiscountAmount}`
            : "No limit";
        },
      },
      {
        Header: "Type",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps: any) => {
          const types = [];
          if (cellProps.isAbandonedCoupon) types.push("Abandoned");
          if (cellProps.isNewUserCoupon) types.push("New User");
          return types.length > 0 ? types.join(" + ") : "Standard";
        },
      },
      {
        Header: "Start Date",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps: any) => {
          return formatDate(cellProps.startDate);
        },
      },
      {
        Header: "Expiry Date",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps: any) => {
          return formatDate(cellProps.expiryDate);
        },
      },
      {
        Header: "Usage",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps: any) => {
          return `${cellProps.usedCount}/${cellProps.usageLimit || "∞"}`;
        },
      },
      {
        Header: "Status",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps: any) => {
          const status = getStatus(cellProps);
          switch (status) {
            case "Active":
              return (
                <span className="badge bg-success-subtle text-success text-uppercase">
                  {status}
                </span>
              );
            case "Expired":
              return (
                <span className="badge bg-danger-subtle text-danger text-uppercase">
                  {status}
                </span>
              );
            case "Inactive":
              return (
                <span className="badge bg-secondary-subtle text-secondary text-uppercase">
                  {status}
                </span>
              );
            default:
              return (
                <span className="badge bg-success-subtle text-success text-uppercase">
                  {status}
                </span>
              );
          }
        },
      },
      {
        Header: "Action",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps: any) => {
          return (
            <ul className="hstack gap-2 list-unstyled mb-0">
              <li>
                <Link
                  to="#couponDetails"
                  data-bs-toggle="offcanvas"
                  className="badge bg-dark-subtle text-body view-item-btn"
                  onClick={() => {
                    setShowCouponsDetails(cellProps);
                    setShowCoupons(!showCoupons);
                  }}
                >
                  View
                </Link>
              </li>
              <li>
                <Button
                  variant="link"
                  className="badge bg-primary-subtle text-primary edit-item-btn p-0 border-0"
                  onClick={() => handleEditCoupon(cellProps)}
                >
                  Edit
                </Button>
              </li>
              <li>
                <Button
                  variant="link"
                  className="badge bg-danger-subtle text-danger remove-item-btn p-0 border-0"
                  onClick={() => {
                    setSelectedCouponId(cellProps._id || cellProps.id);
                    setDeleteModal(true);
                  }}
                >
                  Delete
                </Button>
              </li>
            </ul>
          );
        },
      },
    ],
    [showCoupons]
  );

  const [modal_AddCouponsModals, setmodal_AddCouponsModals] =
    useState<boolean>(false);

  const tog_AddCouponsModals = () => {
    if (modal_AddCouponsModals) {
      // Reset form when closing modal
      resetForm();
    }
    setmodal_AddCouponsModals(!modal_AddCouponsModals);
  };

  const filteredCoupons = useMemo(() => {
    if (!searchTerm) return coupons;
    return coupons.filter((coupon: any) => {
      return coupon.code.toLowerCase().includes(searchTerm.toLowerCase());
    });
  }, [coupons, searchTerm]);

  const paginatedCoupons = useMemo(() => {
    const startIndex = currentPage * pageSize;
    return filteredCoupons.slice(startIndex, startIndex + pageSize);
  }, [filteredCoupons, currentPage, pageSize]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb title="Coupons" pageTitle="More" />
          <div id="couponsList">
            <Row>
              <Col xxl={12}>
                <Card>
                  <Card.Body>
                    <Row className="align-items-center">
                      <Col xxl={3} md={5}>
                        <div className="search-box mb-3 mb-md-0">
                          <input
                            type="text"
                            className="form-control search"
                            id="searchProductList"
                            placeholder="Search by coupons code & name..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                          <i className="ri-search-line search-icon"></i>
                        </div>
                      </Col>
                      <Col className="col-md-auto ms-auto">
                        <Button
                          variant="success"
                          onClick={tog_AddCouponsModals}
                          className="add-btn"
                        >
                          <i className="bi bi-plus-circle me-1 align-middle"></i>
                          Add Coupon
                        </Button>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col lg={12}>
                <Card>
                  <Card.Body className="p-0">
                    <TableContainer
                      columns={columns || []}
                      data={paginatedCoupons}
                      iscustomPageSize={true}
                      isBordered={false}
                      customPageSize={pageSize}
                      className="custom-header-css table align-middle table-nowrap"
                      tableClass="table-centered align-middle table-nowrap mb-0"
                      theadClass="text-muted table-light"
                      SearchPlaceholder="Search Products..."
                      manualPagination={true}
                      pageCount={Math.ceil(filteredCoupons.length / pageSize)}
                      currentPage={currentPage}
                      onPageChange={setCurrentPage}
                      onPageSizeChange={setPageSize}
                    />
                    <div className="noresult" style={{ display: "none" }}>
                      <div className="text-center">
                        <h5 className="mt-2">Sorry! No Result Found</h5>
                        <p className="text-muted mb-0">
                          We've searched more than 150+ Orders We did not find
                          any orders for you search.
                        </p>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </div>

          <Modal
            id="showModal"
            className="fade zoomIn"
            size="lg"
            show={modal_AddCouponsModals}
            onHide={tog_AddCouponsModals}
            centered
          >
            <Modal.Header className="px-4 pt-4" closeButton>
              <h5 className="modal-title fs-18" id="exampleModalLabel">
                {isEditMode ? "Edit Coupon" : "Add Coupon"}
              </h5>
            </Modal.Header>
            <Modal.Body className="p-4">
              <Form className="tablelist-form" onSubmit={handleSubmit}>
                <Row>
                  <Col lg={6}>
                    <div className="mb-3">
                      <Form.Label htmlFor="code">
                        Coupon Code <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        id="code"
                        name="code"
                        value={formData.code}
                        onChange={handleInputChange}
                        placeholder="Enter coupon code"
                        isInvalid={!!formErrors.code}
                        required
                      />
                      <Form.Control.Feedback type="invalid">
                        {formErrors.code}
                      </Form.Control.Feedback>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3">
                      <Form.Label htmlFor="discountType">
                        Discount Type <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Select
                        name="discountType"
                        id="discountType"
                        value={formData.discountType}
                        onChange={handleInputChange}
                      >
                        <option value="percentage">Percentage</option>
                        <option value="fixed">Fixed Amount</option>
                      </Form.Select>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3">
                      <Form.Label htmlFor="discountValue">
                        Discount Value <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="number"
                        id="discountValue"
                        name="discountValue"
                        value={formData.discountValue}
                        onChange={handleInputChange}
                        placeholder="Enter discount value"
                        min="0"
                        step="0.01"
                        isInvalid={!!formErrors.discountValue}
                        required
                      />
                      <Form.Control.Feedback type="invalid">
                        {formErrors.discountValue}
                      </Form.Control.Feedback>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3">
                      <Form.Label htmlFor="minimumPurchaseAmount">
                        Minimum Purchase Amount (₹)
                      </Form.Label>
                      <Form.Control
                        type="number"
                        id="minimumPurchaseAmount"
                        name="minimumPurchaseAmount"
                        value={formData.minimumPurchaseAmount}
                        onChange={handleInputChange}
                        placeholder="Enter minimum purchase amount"
                        min="0"
                        isInvalid={!!formErrors.minimumPurchaseAmount}
                      />
                      <Form.Control.Feedback type="invalid">
                        {formErrors.minimumPurchaseAmount}
                      </Form.Control.Feedback>
                    </div>
                  </Col>
                  {formData.discountType === "percentage" && (
                    <Col lg={6}>
                      <div className="mb-3">
                        <Form.Label htmlFor="maxDiscountAmount">
                          Max Discount Amount (₹)
                        </Form.Label>
                        <Form.Control
                          type="number"
                          id="maxDiscountAmount"
                          name="maxDiscountAmount"
                          value={formData.maxDiscountAmount}
                          onChange={handleInputChange}
                          placeholder="Enter max discount amount"
                          min="0"
                          isInvalid={!!formErrors.maxDiscountAmount}
                        />
                        <Form.Control.Feedback type="invalid">
                          {formErrors.maxDiscountAmount}
                        </Form.Control.Feedback>
                      </div>
                    </Col>
                  )}
                  <Col lg={6}>
                    <div className="mb-3">
                      <Form.Label htmlFor="startDate">
                        Start Date <span className="text-danger">*</span>
                      </Form.Label>
                      <Flatpickr
                        className={`form-control flatpickr-input ${
                          formErrors.startDate ? "is-invalid" : ""
                        }`}
                        placeholder="Select start date"
                        options={{
                          dateFormat: "d M, Y",
                          minDate: "today",
                        }}
                        value={formData.startDate}
                        onChange={handleDateChange("startDate")}
                      />
                      {formErrors.startDate && (
                        <div className="invalid-feedback d-block">
                          {formErrors.startDate}
                        </div>
                      )}
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3">
                      <Form.Label htmlFor="expiryDate">
                        Expiry Date <span className="text-danger">*</span>
                      </Form.Label>
                      <Flatpickr
                        className={`form-control flatpickr-input ${
                          formErrors.expiryDate ? "is-invalid" : ""
                        }`}
                        placeholder="Select expiry date"
                        options={{
                          dateFormat: "d M, Y",
                          minDate: formData.startDate || "today",
                        }}
                        value={formData.expiryDate}
                        onChange={handleDateChange("expiryDate")}
                      />
                      {formErrors.expiryDate && (
                        <div className="invalid-feedback d-block">
                          {formErrors.expiryDate}
                        </div>
                      )}
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3">
                      <Form.Label htmlFor="usageLimit">
                        Usage Limit (How Many Person will Use)
                      </Form.Label>
                      <Form.Control
                        type="number"
                        id="usageLimit"
                        name="usageLimit"
                        value={formData.usageLimit}
                        onChange={handleInputChange}
                        placeholder="Enter usage limit"
                        min="1"
                        isInvalid={!!formErrors.usageLimit}
                      />
                      <Form.Control.Feedback type="invalid">
                        {formErrors.usageLimit}
                      </Form.Control.Feedback>
                    </div>
                  </Col>
                  {/* <Col lg={6}>
                    <div className="mb-3">
                      <Form.Label>Valid For Users</Form.Label>
                      <div className="input-group">
                        <Form.Control
                          type="text"
                          value={userInput}
                          onChange={(e) => setUserInput(e.target.value)}
                          placeholder="Enter user ID"
                        />
                        <Button
                          variant="outline-secondary"
                          onClick={handleAddUser}
                        >
                          Add
                        </Button>
                      </div>
                      {validForUsers.length > 0 && (
                        <div className="mt-2">
                          {validForUsers.map((userId) => (
                            <span
                              key={userId}
                              className="badge bg-primary me-1"
                            >
                              {userId}
                              <button
                                type="button"
                                className="btn-close btn-close-white ms-1"
                                style={{ fontSize: "0.5rem" }}
                                onClick={() => handleRemoveUser(userId)}
                                aria-label="Remove"
                              ></button>
                            </span>
                          ))}
                        </div>
                      )}
                    </div>
                  </Col> */}
                  <Col lg={6}>
                    <div className="mb-3">
                      <Form.Check
                        type="checkbox"
                        id="isAbandonedCoupon"
                        label="Is Abandoned Cart Coupon"
                        name="isAbandonedCoupon"
                        checked={formData.isAbandonedCoupon}
                        onChange={handleInputChange}
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3">
                      <Form.Check
                        type="checkbox"
                        id="isNewUserCoupon"
                        label="Is New User Coupon"
                        name="isNewUserCoupon"
                        checked={formData.isNewUserCoupon}
                        onChange={handleInputChange}
                      />
                    </div>
                  </Col>

                  {isEditMode && (
                    <Col lg={6}>
                      <div className="mb-3">
                        <Form.Label htmlFor="isActive">Status</Form.Label>
                        <Form.Select
                          name="isActive"
                          id="isActive"
                          value={formData.isActive.toString()}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              isActive: e.target.value === "true",
                            }))
                          }
                        >
                          <option value="true">Active</option>
                          <option value="false">Inactive</option>
                        </Form.Select>
                      </div>
                    </Col>
                  )}
                  <Col lg={12} className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <Button
                        variant="light"
                        onClick={tog_AddCouponsModals}
                        disabled={loading}
                      >
                        <i className="ri-close-line align-bottom me-1"></i>
                        Close
                      </Button>
                      <Button
                        variant="primary"
                        type="submit"
                        disabled={loading}
                      >
                        {loading ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-1"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            {isEditMode ? "Updating..." : "Creating..."}
                          </>
                        ) : (
                          <>
                            <i
                              className={`ri-${
                                isEditMode ? "edit" : "save"
                              }-line align-bottom me-1`}
                            ></i>
                            {isEditMode ? "Update Coupon" : "Add Coupon"}
                          </>
                        )}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </Modal.Body>
          </Modal>
        </Container>
      </div>

      <Offcanvas
        show={showCoupons}
        onHide={() => setShowCoupons(!showCoupons)}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            {showCouponDetails.code || "Coupon Details"}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="mt-3">
            <div className="table-responsive">
              <table className="table table-borderless">
                <tbody>
                  <tr>
                    <td>
                      <span className="text-muted">Code</span>
                    </td>
                    <td>
                      <span className="fw-medium">
                        {showCouponDetails.code}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span className="text-muted">Discount</span>
                    </td>
                    <td>
                      <span className="fw-medium text-uppercase">
                        {showCouponDetails.discountType === "percentage"
                          ? `${showCouponDetails.discountValue}%`
                          : `₹${showCouponDetails.discountValue}`}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span className="text-muted">Min. Purchase</span>
                    </td>
                    <td>
                      <span className="fw-medium">
                        {showCouponDetails.minimumPurchaseAmount > 0
                          ? `₹${showCouponDetails.minimumPurchaseAmount}`
                          : "No minimum"}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span className="text-muted">Max Discount</span>
                    </td>
                    <td>
                      <span className="fw-medium">
                        {showCouponDetails.maxDiscountAmount
                          ? `₹${showCouponDetails.maxDiscountAmount}`
                          : "No limit"}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span className="text-muted">Coupon Type</span>
                    </td>
                    <td>
                      <span className="fw-medium">
                        {showCouponDetails.isAbandonedCoupon &&
                          "Abandoned Cart "}
                        {showCouponDetails.isNewUserCoupon && "New User "}
                        {!showCouponDetails.isAbandonedCoupon &&
                          !showCouponDetails.isNewUserCoupon &&
                          "Standard"}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span className="text-muted">Start Date</span>
                    </td>
                    <td>
                      <span className="fw-medium">
                        {showCouponDetails.startDate &&
                          formatDate(showCouponDetails.startDate)}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span className="text-muted">Expiry Date</span>
                    </td>
                    <td>
                      <span className="fw-medium">
                        {showCouponDetails.expiryDate &&
                          formatDate(showCouponDetails.expiryDate)}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span className="text-muted">Usage</span>
                    </td>
                    <td>
                      <span className="fw-medium">
                        {showCouponDetails.usedCount}/
                        {showCouponDetails.usageLimit || "∞"}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span className="text-muted">Type</span>
                    </td>
                    <td>
                      <span className="fw-medium">
                        {showCouponDetails.isAbandonedCoupon &&
                          "Abandoned Cart "}
                        {showCouponDetails.isNewUserCoupon && "New User "}
                        {!showCouponDetails.isAbandonedCoupon &&
                          !showCouponDetails.isNewUserCoupon &&
                          "Standard"}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span className="text-muted">Valid For Users</span>
                    </td>
                    <td>
                      {showCouponDetails.validForUsers?.length > 0 ? (
                        <div>
                          {showCouponDetails.validForUsers.map(
                            (userId: string) => (
                              <span
                                key={userId}
                                className="badge bg-primary me-1"
                              >
                                {userId}
                              </span>
                            )
                          )}
                        </div>
                      ) : (
                        <span className="fw-medium">All Users</span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span className="text-muted">Status</span>
                    </td>
                    <td>
                      <span
                        className={
                          getStatus(showCouponDetails) === "Expired"
                            ? "badge bg-danger-subtle text-danger text-uppercase"
                            : getStatus(showCouponDetails) === "Inactive"
                            ? "badge bg-secondary-subtle text-secondary text-uppercase"
                            : "badge bg-success-subtle text-success text-uppercase"
                        }
                      >
                        {getStatus(showCouponDetails)}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      {/* Delete Modal */}
      <Modal show={deleteModal} onHide={() => setDeleteModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title as="h5">Delete Coupon</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Are you sure you want to delete this coupon? This action cannot be
            undone.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => setDeleteModal(false)}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={handleDeleteCoupon}
            disabled={loading}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-1"
                  role="status"
                  aria-hidden="true"
                ></span>
                Deleting...
              </>
            ) : (
              "Delete"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default Coupons;
